import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import ReactQuill from 'react-quill'
import { Button, Glyphicon } from 'react-bootstrap'

import { handleErrorFetchingData } from '../../functions/errorHandling'

import { parseTitleFromHtml } from '../../functions/reactQuillHandling'

class EditUpdate extends Component {
  state = {
    body: '',
    savingUpdate: false,
  }

  componentDidMount() {
    this.setState( { body: this.props.update.body })
  }

  handleInput = (body) => this.setState({ body })

  handleSave = () => {
    const { update, currentUser } = this.props
    const { body, savingUpdate } = this.state

    if (!body || body === '<p><br></p>') {
      return swal({
        title: "Error",
        text: `Please enter text in the update field before saving`,
        icon: "error",
        button: "Continue",
      })
    }

    if (savingUpdate) {
      return
    }

    this.setState({ savingUpdate: true })

    const name = parseTitleFromHtml(body)

    axios({
      method: "PATCH",
      url: update.url,
      data: { name, body },
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
    })
    .then(response => {
      let update = response.data
      const created_by = {...currentUser, id: currentUser.pk}
      update = {...update, created_by}
      this.setState({ savingUpdate: false })
      this.props.editUpdate(update)
      this.props.toggleEditMode()
    })
    .catch(error => {
      this.setState({ savingUpdate: false })
      const message = "There was an error saving your update."
      return handleErrorFetchingData(error, message)
    })
  }

  render() {
      const { savingUpdate } = this.state

    return (
      <div>
        <ReactQuill
          value={this.state.body}
          theme="snow"
          placeholder="Enter update..."
          onChange={this.handleInput}
          readOnly={savingUpdate}
        />

        <br/>

        <Button
          style={{margin: '0 10px 0 0'}}
          onClick={savingUpdate ? () => null : this.props.toggleEditMode}
          disabled={savingUpdate}
        >
          Cancel
        </Button>

        <Button
          style={{margin: '0 0 0 10px'}}
          bsStyle="primary"
          onClick={this.handleSave}
        >
          {savingUpdate ?
            <Glyphicon
              glyph='refresh'
              style={{minWidth: '28px'}}
              className='rotate-btn'
            />
            :
            'Save'
          }
        </Button>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
  }
}

export default connect(mapStateToProps)(EditUpdate)



// WEBPACK FOOTER //
// ./src/reuseable-components/updates/EditUpdate.js